__turbopack_context__.v({
  "content": "styles-module-scss-module__zdIO5G__content",
  "desktop": "styles-module-scss-module__zdIO5G__desktop",
  "headerDesk": "styles-module-scss-module__zdIO5G__headerDesk",
  "image": "styles-module-scss-module__zdIO5G__image",
  "logo": "styles-module-scss-module__zdIO5G__logo",
  "menu": "styles-module-scss-module__zdIO5G__menu",
  "navigation": "styles-module-scss-module__zdIO5G__navigation",
  "slideDown": "styles-module-scss-module__zdIO5G__slideDown",
  "slideDownSubHeader": "styles-module-scss-module__zdIO5G__slideDownSubHeader",
  "slideDownSubHeaderUp": "styles-module-scss-module__zdIO5G__slideDownSubHeaderUp",
  "slideUp": "styles-module-scss-module__zdIO5G__slideUp",
  "stickyDown": "styles-module-scss-module__zdIO5G__stickyDown",
  "stickyUp": "styles-module-scss-module__zdIO5G__stickyUp",
  "subHeaderDesk": "styles-module-scss-module__zdIO5G__subHeaderDesk",
  "subMenu": "styles-module-scss-module__zdIO5G__subMenu",
  "subMenuChild": "styles-module-scss-module__zdIO5G__subMenuChild",
  "subMenuGrid": "styles-module-scss-module__zdIO5G__subMenuGrid",
  "subMenuGridSub": "styles-module-scss-module__zdIO5G__subMenuGridSub",
  "topBar": "styles-module-scss-module__zdIO5G__topBar",
});
